import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { FilterItem } from '@pos/interfaces/pos-session';
import { ReportDataCollection } from '@pos/interfaces/pos-session';
import moment from 'moment';
@Component({
  name: 'bpc-pos-session-report',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class PosSessionReport extends mixins(AbstractField) {
  public reportObservableSubscription = null;
  public reportData: ReportDataCollection[] = [];
  public methods = [];
  public fields = [
    { key: 'date', label: this.$t('global.report.date'), sortable: false },
    { key: 'hour', label: this.$t('global.report.hour'), sortable: false },
    { key: 'client', label: this.$t('global.report.client'), sortable: false },
    { key: 'journal', label: this.$t('global.report.journal'), sortable: false },
    { key: 'ticket', label: this.$t('global.report.ticket'), sortable: false },
    {
      key: 'amount',
      label: this.$t('global.report.amount'),
      sortable: false,
      thClass: 'text-right pr-2',
      tdClass: 'text-right pr-2',
    },
  ];

  get posSessionId(): number {
    const filters = (this.$attrs?.filters || []) as FilterItem[];
    const filter = filters.find(item => {
      return item?.filterField === 'pos_session_id';
    });
    return filter?.value;
  }

  public mounted() {
    this.getReportByPosSession();
  }

  get getMethods() {
    Object.entries(this.reportData).forEach(data => {
      this.methods.push(data[0]);
    });
    return this.methods;
  }

  public itemsByMethod(method: string) {
    const items = [];
    if (this.reportData !== null) {
      Object.entries(this.reportData).forEach(data => {
        if (data[0] === method) {
          data[1].forEach(function(data2) {
            items.push({
              date: moment(String(data2.date)).format('DD/MM/YYYY'),
              hour: moment(String(data2.time), 'HH:mm').format('HH:mm'),
              client: data2.client,
              journal: data2.journal,
              ticket: data2.ticket,
              amount: (Math.round(data2.amount * 100) / 100).toFixed(2).replace('.', ',') + ' €',
            });
          });
        }
      });
    }
    return items;
  }

  public totalAmountByMethod(method: string) {
    let price = 0;
    Object.entries(this.reportData).forEach(data => {
      if (data[0] === method) {
        data[1].forEach(data2 => {
          price += data2.amount;
        });
      }
    });
    return (Math.round(price * 100) / 100).toFixed(2).replace('.', ',');
  }

  get getTotalAmount() {
    let totalAmount = 0;
    Object.entries(this.reportData).forEach(data => {
      data[1].forEach(data2 => {
        totalAmount += data2.amount;
      });
    });
    return (Math.round(totalAmount * 100) / 100).toFixed(2).replace('.', ',');
  }

  public getReportByPosSession() {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('pos-sessions')}/${
      this.posSessionId
    }/session-report`;

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(fetchEntityPath);

    if (this.reportObservableSubscription) {
      this.reportObservableSubscription.unsubscribe();
    }

    this.reportObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.reportData = res.data;
      },
      error => {
        console.log(error);
      },
    );
  }

  public async downloadReport() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('pos-sessions');
    const relativePath = `/${this.posSessionId}/session-report/download`;
    this.$bpcApi.postDownload(`${basePath + relativePath}`, '').subscribe();
  }
}
